import CrmApi from '../../../api/CrmApi';
import EvidenceKind from '../../constants-v2/bookkeeping/evidence-kind.js';
import crmName from '../../filters/crm-name';
import HttpBuildQuery from '../../procedures/http-build-query';
import FiltersType from './listingFiltersTypesConstants';

export default {
  path: '/billing',
  filters: [
    {
      key: 'fulltext',
      placeholder: 'Wpisz frazę do znalezienia',
      shortPlaceholder: 'Szukaj',
      badge: 'Szukana fraza:',
      testName: 'hub_filter_search',
      inputType: FiltersType.TEXT_SEARCH_TYPE,
      reset: async () => ({ value: '' }),
    },
    {
      key: 'evidencekind.id',
      getItems: async () => [
        { value: EvidenceKind.INCOME, label: 'Przychód' },
        { value: EvidenceKind.COST, label: 'Koszt' },
      ],
      reset: async () => null,
      placeholder: 'Rodzaj',
      badge: 'Rodzaj:',
      testName: 'test_filter_evidence_kind',
      inputType: FiltersType.SELECT_TYPE,
    },
    {
      key: 'settlement_status',
      getItems: async () => [
        { value: 'settled', label: 'TAK' },
        { value: 'pending', label: 'NIE' },
        { value: 'partially_settled', label: 'Niedopłata' },
        { value: 'manually_settled', label: 'Ręcznie rozliczono' },
        { value: 'pending_to_manual_match', label: 'Brak dopasowania' },
      ],
      reset: async () => null,
      placeholder: 'Zapłacono',
      badge: 'Zapłacono:',
      testName: 'test_filter_evidence_status',
      inputType: FiltersType.SELECT_TYPE,
    },
    {
      key: 'entry_date',
      reset: async () => ({ value: { fromVal: null, toVal: null } }),
      placeholder: '',
      badge: 'Data wpisu:',
      testName: 'test_filter_evidence_entry_date',
      inputType: FiltersType.RANGE_TYPE,
      htmlInputType: 'date',
    },
    {
      key: 'payment_deadline',
      reset: async () => ({ value: { fromVal: null, toVal: null } }),
      placeholder: '',
      badge: 'Termin płatności:',
      testName: 'test_filter_evidence_payment_deadline',
      inputType: FiltersType.RANGE_TYPE,
      htmlInputType: 'date',
    },
    {
      key: '_number_of_days_due',
      reset: async () => ({ value: { fromVal: null, toVal: null } }),
      placeholder: '',
      badge: 'Ilość dni zaległości:',
      testName: 'test_filter_evidence_number_of_days_due',
      inputType: FiltersType.RANGE_TYPE,
      htmlInputType: 'number',
    },
    {
      key: '_evidence_clients_multi',
      getItems: async () => {
        let { data } = await CrmApi.index(HttpBuildQuery({ list: true }));
        delete data.pagination;

        return Object.values(data)
          .map((item) => {
            return {
              value: item.client.person.company.original,
              label: `${ crmName(item) }`,
            };
          });
      },
      reset: async () => null,
      placeholder: 'Kontrahent',
      badge: 'Kontrahent:',
      testName: 'test_filter_evidence_client',
      inputType: FiltersType.MULTI_SELECT_TYPE,
    },
  ],
};
